import Button from "components/atoms/buttons/Button";
import NotificationCardForPage from "components/atoms/cards/notification/NotificationCardForPage";
import { OnboardingBackIcon } from "components/atoms/Icon";
import { useRouter } from "components/hooks";
import FilterButtons from "pages/BrandDiscover/components/FilterButtons";
import { useMemo, useState } from "react";
import DefaultImage from "../../assets/Images/BrandImage1.png";

type Props = {
  notifications: NotificationData[];
  unreadNotificationsCount: number;
  handleMarkAllNotificationsAsRead: () => void;
  handleMarkNotificationAsReadAndNavigateToCta: (notification: NotificationData) => void;
};

const filterOptions = ["All", "Read", "Unread"] as const;

function Notification({
  notifications,
  unreadNotificationsCount,
  handleMarkAllNotificationsAsRead,
  handleMarkNotificationAsReadAndNavigateToCta,
}: Props) {
  const router = useRouter();

  const handleBackButtonClick = () => {
    router.go(-1);
  };

  const [currentTab, setCurrentTab] = useState<string>("All");

  const handleSetFilter = (filter: string) => {
    setCurrentTab(filter);
  };

  const filteredNotifications = useMemo(() => {
    switch (currentTab as typeof filterOptions[number]) {
      case "All":
        return notifications;
      case "Read":
        return notifications.filter((n) => n.is_read);
      case "Unread":
        return notifications.filter((n) => !n.is_read);
      default:
        throw new Error("Invalid Filter Option ");
    }
  }, [currentTab, notifications]);

  return (
    <div className="mx-auto mt-6 w-full max-w-3xl 2xl:mt-8">
      <button
        type="button"
        className="flex items-center justify-center gap-2
             font-sora text-sm font-semibold text-white"
        onClick={handleBackButtonClick}
      >
        <OnboardingBackIcon />
        <p>BACK</p>
      </button>
      <div className="mt-2 flex items-center space-x-4 2xl:mt-4 2xl:space-x-4">
        <p className="text-4xl font-semibold text-white 2xl:text-5xl">Notification</p>
        {unreadNotificationsCount ? (
          <p
            className="flex h-8 w-8
                    items-center justify-center rounded-full bg-accent font-satoshi text-xs font-semibold
                    leading-none text-primary 2xl:h-8 2xl:w-8
                      2xl:text-lg"
          >
            {unreadNotificationsCount}
          </p>
        ) : null}
      </div>
      <div className="my-5 mb-5 flex items-center justify-between 2xl:mb-7">
        <div>
          <FilterButtons
            onFilterSelect={handleSetFilter}
            className=""
            filterOptions={filterOptions as unknown as string[]}
          />
        </div>
        <Button
          additionalClasses="!font-medium xl:text-xs 2xl:text-sm"
          text="Mark All as Read"
          onClick={handleMarkAllNotificationsAsRead}
          variant="primary"
        />
      </div>
      <div
        className="secondary-scrollbar
         flex h-[62vh] flex-col gap-y-1.5 overflow-x-hidden overflow-y-scroll pr-3
       2xl:h-[65vh] 2xl:gap-y-2.5"
      >
        {filteredNotifications.map((notification: NotificationData) => (
          <NotificationCardForPage
            key={`Notification-${notification.id}`}
            title={notification.title}
            image={notification.image_url || DefaultImage}
            description={notification.description}
            createdAt={notification.created_at}
            handleMarkNotificationAsReadAndNavigateToCta={() =>
              handleMarkNotificationAsReadAndNavigateToCta(notification)
            }
          />
        ))}
      </div>
    </div>
  );
}
export default Notification;
